module.exports = {
          srcSet: "/_next/static/images/img-telephonie@2x-160-67f45cec3e1693bc57278642d56a521a.webp"+" 160w"+","+"/_next/static/images/img-telephonie@2x-292-ca04273ac1c0033a108528c3d2b5e58d.webp"+" 292w",
          images:[ {path: "/_next/static/images/img-telephonie@2x-160-67f45cec3e1693bc57278642d56a521a.webp",width: 160,height: 137},{path: "/_next/static/images/img-telephonie@2x-292-ca04273ac1c0033a108528c3d2b5e58d.webp",width: 292,height: 250}],
          src: "/_next/static/images/img-telephonie@2x-160-67f45cec3e1693bc57278642d56a521a.webp",
          toString:function(){return "/_next/static/images/img-telephonie@2x-160-67f45cec3e1693bc57278642d56a521a.webp"},
          placeholder: undefined,
          width: 160,
          height: 137
      }